import React, { useState } from 'react'
import classNames from 'classnames'

// @material-ui
import {
  Icon,
  Card,
  CardContent,
  Button,
  //  Typography
} from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

// core
import { Loading } from '_core/components/Loading'
import { Price } from '_core/components/Price'
import Label from '_core/components/Label/Label'
import Value from '_core/components/Value/Value'
import { Flex } from '_core/components/Flex'
import SimpleSlider from '_core/components/SimpleSlider/SimpleSlider'
import { ModalInner } from '_core/components/ModalInner'
import { ModalOuter } from '_core/components/ModalOuter'

// style
import simpleCardStyle from '_core/components/SimpleCard/simpleCardStyle'

const SimpleCard = props => {
  const {
    classes,
    titleHeight,
    icon,
    value,
    target,
    title,
    format,
    elevation,
    sliderValue,
    currency,
    minHeightOff,
    minHeight,
    modal,
    modalMaxWidth,
  } = props

  const [modalOpen, setModalOpen] = useState(false)

  const _toggleClaimsModal = isModalOpen => {
    setModalOpen(isModalOpen)
  }

  const isActive = value === 0 && target != null

  const cardClasses = classNames({
    [classes.simpleCard]: true,
    [classes.cardActive]: isActive,
    [classes.minHeightOff]: minHeightOff,
    [classes.withIcon]: icon,
    [classes.modal]: modal,
  })

  const cardContentClasses = classNames({
    [classes.cardContent]: true,
    [classes.minHeightOff]: minHeightOff,
  })

  const titleClasses = classNames({
    [classes.title]: true,
    [classes.titleHeight]: titleHeight,
    [classes.titleMargin]: icon,
  })

  return (
    <>
      <Card
        className={cardClasses}
        elevation={elevation}
        // active={isActive}
      >
        {icon != null ? (
          <Flex
            justifyContent="center"
            alignItems="center"
            className={classes.iconContainer}
          >
            <Icon className={classes.smallIcon}>{icon}</Icon>
          </Flex>
        ) : null}

        <CardContent
          className={cardContentClasses}
          style={minHeight && { minHeight: minHeight }}
        >
          {title != null ? (
            <Label className={titleClasses}>{title}</Label>
          ) : null}
          {value != null ? (
            <Value className={classes.simpleValue} autoSize={true}>
              {value > 0 ? '+ ' : null}

              {format != null ? (
                <Price currency={currency} value={value} />
              ) : (
                value
              )}
            </Value>
          ) : (
            <Loading />
          )}

          {target != null && !isActive ? (
            <SimpleSlider value={sliderValue} target={target} />
          ) : null}
          {modal != null ? (
            <Button size="small" onClick={() => _toggleClaimsModal(true)}>
              Подробнее
            </Button>
          ) : null}
        </CardContent>
      </Card>

      {modal != null ? (
        <ModalOuter
          open={modalOpen}
          fullWidth={true}
          maxWidth={modalMaxWidth != null ? modalMaxWidth : 'md'}
          onClose={() => _toggleClaimsModal(false)}
        >
          <ModalInner
            // hasHeader={false}
            // smallHeader
            // header={
            //   <>
            //     {icon && <Icon className={classes.icon}>{icon}</Icon>}
            //     <Typography variant="h6" className={classes.title}>
            //       {title}
            //     </Typography>
            //     {props.subtitle && (
            //       <Typography variant="body1" className={classes.subtitle}>
            //         {props.subtitle}
            //       </Typography>
            //     )}
            //   </>
            // }
            title={title}
            icon={icon}
            content={modal}
          />
        </ModalOuter>
      ) : null}
    </>
  )
}

export default withStyles(simpleCardStyle)(SimpleCard)
